.phoneGroup {
  padding-bottom: 5px !important;
}

.phoneInfo {
  padding: 0 25px 25px;
  font-size: 11px;
  line-height: 1.2em;
}
